import React from "react";
import styled from "styled-components";
const Body = styled.div`
	width: 97%;
	margin: auto;
	margin-top: 20px;
	padding: 2rem 0;
	@media screen and (min-width: 481px) {
		padding: 2rem;
		border-radius: 16px;
		margin: 1rem 0;
		box-shadow: 0 0 22px 1px #e2e2e2dd;
	}
`;
function Container({ children }) {
  return <Body>{children}</Body>;
}

export default Container;
